module.exports = __webpack_public_path__ + "img/discount-icon.bcd8569.png";